import { render, staticRenderFns } from "./CollegePurchaseDepartmentHodClass.vue?vue&type=template&id=050ad924"
import script from "./CollegePurchaseDepartmentHodClass.vue?vue&type=script&lang=js"
export * from "./CollegePurchaseDepartmentHodClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports